<template>
    <div class="page-table-layout" data-testid="threshold-new">
        <v-card :loading="loading" :disabled="loading" loader-height="2" class="all-width flex-card shadow-off" data-testid="threshold-new__main-card">
            <v-card-text class="page-table-layout__body" data-testid="threshold-new__main-content">
                <div class="d-flex align-center justify-space-between" data-testid="threshold-new__header-bar">
                    <div class="d-flex align-center" data-testid="threshold-new__header-title-group">
                        <h3 class="ma-0  black--text font-weight-medium" data-testid="threshold-new__header-title">Threshold</h3>

                        <v-tooltip bottom content-class="tooltip-bottom">
                            <template v-slot:activator="{ on, attrs }"> 
                                <v-btn 
                                    v-bind="attrs"
                                    v-on="on"
                                    class="shadow-off ml-1" icon @click="refreshData()" data-testid="threshold-new__refresh-btn"><v-icon
                                    size="24" data-testid="threshold-new__refresh-icon">mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>Refresh</span>
                        </v-tooltip>
                    </div>
                    <div class="d-flex align-center justify-center" data-testid="threshold-new__header-action-group">
                        <v-btn  color="primary" class="mr-1 px-4"
                            v-if="$nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add')"
                            @click="locationdialog = true; locationdata = {}; locationdataerror = {};" data-testid="threshold-new__add-btn">
                            <v-icon class="mr-1" data-testid="threshold-new__add-icon">mdi-plus</v-icon>
                            <span>Add Threshold</span>
                        </v-btn>
                    </div>
                </div>

                <div class="d-flex align-center ml-0 mr-1 justify-space-between my-3 " data-testid="threshold-new__toolbar">
                    <div class="d-none"> 
                        <lb-string placeholder="Search" label="" v-model="search" width="30vh" appendiconinner="mdi-magnify"
                            hidedetails :isClearable="false" radius="8px" />
                        <v-tooltip bottom content-class="tooltip-bottom">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="ma-2" text icon color="lighten-2" v-bind="attrs" v-on="on">
                                    <v-icon>mdi-information</v-icon>
                                </v-btn>
                            </template>
                            <span>Search for the name</span>
                        </v-tooltip>
                    </div>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <!-- Clear Filter Button -->
                    <v-btn
                        v-if="hasActiveTableFilter"
                        outlined
                        small
                        class="mr-2"
                        color="caccounting"
                        @click="clearTableFilter()"
                        data-testid="threshold-new__toolbar-clear-filter-btn"
                    >
                        <v-icon left data-testid="threshold-new__toolbar-clear-filter-icon">mdi-filter-remove</v-icon>
                        <span>Clear Filter</span>
                    </v-btn>
                    <!-- CustomizeColumnMenu component - Apply only -->
                    <CustomizeColumnMenu
                      v-model="customizeMenuOpen"
                      :headers="headers"
                      color="caccounting"
                      :show-save-button="false"
                      :show-apply-button="true"
                      data-testid-prefix="threshold-new"
                      @apply="handleApplyColumns"
                    />
                </div>

                <div class="flex-fill-table">
                <lb-datatableaction ref="dataTableAction" :headers="headers" :tabledata="formatedDataCopy" :itemsperpage="itemsPerPage"
                    :displayedRowCount="paginatedFilteredItems.length"
                    :searchterm="search" :bulkActions="false" @filter-item="filterPart" @filter-active-change="onFilterActiveChange" @clear-item="clearPart" data-testid="threshold-new__datatable">
                    <template v-slot:tbody>
                        <tr v-for="item in paginatedFilteredItems" :key="item._id" class="cursor-pointer  "
                            :class="{ 'low-opacity': item.status === false }" data-testid="threshold-new__row">
                            <template v-for="header in headers">
                                <td v-if="header.visible && header.value !== 'action'" :key="header.value"
                                    :class="{ 'description-header': header.value === 'name' }" class="px-2 single-line" data-testid="threshold-new__cell">
                                    <span data-testid="threshold-new__cell-value"> {{ getItemData(item, header.value) }}</span>
                                </td>
                                <td v-else-if="header.value === 'action'" :key="header.value"
                                    class=" px-0 single-line border-right border-left action-data cursor-default" data-testid="threshold-new__action-cell">
                                    <v-tooltip bottom content-class="tooltip-bottom">
                                        <template v-slot:activator="{ on, attrs }"> 
                                            <v-btn v-bind="attrs" v-on="on" icon @click="editThreshold(item)" :disabled="!item.status" data-testid="threshold-new__edit-btn"><v-icon data-testid="threshold-new__edit-icon">mdi-pencil-outline</v-icon></v-btn>
                                        </template>
                                        <span>Edit</span>
                                    </v-tooltip>
                                    <v-tooltip bottom content-class="tooltip-bottom" v-if="!item.status">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on" color="error" @click="enableDisableThreshold(item, 'enable', item.status)" data-testid="threshold-new__enable-btn">
                                                <v-icon>mdi-close-circle</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Enable</span>
                                    </v-tooltip>
                                    <v-tooltip bottom content-class="tooltip-bottom" v-else>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on" color="success" @click="enableDisableThreshold(item, 'disable', item.status)" data-testid="threshold-new__disable-btn">
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Disable</span>
                                    </v-tooltip>
                                        <activity-log
                                        :resource-id="item._id" 
                                        data-testid="threshold-new__activity-log-btn"
                                        :row-description="item.name"
                                    />
                                </td>
                            </template>
                        </tr>
                    </template>
                </lb-datatableaction>
                </div>
            </v-card-text>
        </v-card>

        <lb-drawer v-model="locationdialog" :heading="locationdata._id ? 'Edit Threshold' : 'Add Threshold'" width="600"
            :loading="locationdialogloading" data-testid="threshold-new__drawer">
            <template v-slot:body>
                <div data-testid="threshold-new__drawer-body">
                    <v-row data-testid="threshold-new__drawer-row">
                        <v-col cols="12" class="my-0 py-1" data-testid="threshold-new__drawer-col-location">
                            <p class="pa-0 ma-0  text-font-size-md mb-1">{{$store.state.LocationHeader || 'Location' }} Name*</p>
                            <lb-dropdown v-model="locationdata.name" :items="locationList" label=""
                                :error="locationdataerror.location" itemtext="name" itemvalue="value"
                                :readonly="locationdata._id ? true : false"
                                :clearable="locationdata._id ? false : true" data-testid="threshold-new__drawer-location-dropdown" />
                        </v-col>

                        <v-col cols="12" class="my-0 py-1" data-testid="threshold-new__drawer-col-threshold">
                            <p class="pa-0 ma-0  text-font-size-md mb-1">Threshold*</p>
                            <lb-number v-model="locationdata.threshold" label="" min="0" placeholder="Threshold value"
                                :error="locationdataerror.threshold" data-testid="threshold-new__drawer-threshold-input" />
                        </v-col>
                    </v-row>
                </div>
            </template>
            <template v-slot:actions>
                <v-switch :label="enableSwitch === true ? 'Enable' : ' Disable'" class="mt-0" v-model="enableSwitch"
                    @onchange="toggleSwitch(locationdata)" inset hide-details data-testid="threshold-new__drawer-switch"></v-switch>
                <v-spacer></v-spacer>
                <v-btn color="primary" data-testid="threshold-new__drawer-submit-btn">
                    <span v-if="locationdata._id" @click="updateThreshold(locationdata)" data-testid="threshold-new__drawer-update-label">Update</span>
                    <span v-else @click="addThreshold()" data-testid="threshold-new__drawer-add-label">Add</span>
                </v-btn>
            </template>
        </lb-drawer>

        <!-- Pagination -->
        <Pagination :list="filteredItemsfromsearch" :itemsperpage="itemsPerPage" @paginated-data="setPaginatedData" data-testid="threshold-new__pagination" />

    </div>
</template>

<script>
import Pagination from "../../components/Pagination/Pagination.vue";
import CustomizeColumnMenu from "../../components/CustomizeColumnMenu/CustomizeColumnMenu.vue";
import ActivityLog from "../../components/ActivityLog/ActivityLog.vue";
export default {
    data() {
        return {
            right: 'financialclose_master_threshold',
            locationdialog: false,
            locationdialogloading: false,
            locationdata: {},
            locationdataerror: {},
            loading: false,
            hasActiveTableFilter: false,
            locationtypeItem: [],
            formatedData: [],
            formatedDataCopy: [],
            locationListdata: [],
            locationList: [],
            locationtypedialog: false,
            customizeMenuOpen: false,
            headers: [
                {
                    value: "name",
                    text: "Name",
                    visible: true,
                    filterable: true,
                    sortable: true,
                },
                {
                    value: "threshold",
                    text: "Threshold",
                    visible: true,
                    filterable: true,
                    sortable: true,
                },
                {
                    value: "action",
                    text: "Action",
                    sortable: false,
                    datatype: "action",
                    lock: true,
                    visible: true,
                    alignment: "text-center",
                },
            ],
            listdata: [],
            enableSwitch: true,
            searchcolumn: "",
            searchTerm: "",
            search: "",
            itemsPerPage: 13,
            paginatedFilteredItems:[],
            activeFilter: null,
        };
    },
    created() {
        this.refreshData();
    },
    activated() {
        this.refreshData();
    },
    components: {
        Pagination,
        CustomizeColumnMenu,
       ActivityLog
    },
    computed: {
        filteredHeaders() {
            const searchTerm = this.searchcolumn?.toLowerCase();
            return this.headers.filter(header =>
                header.value?.toLowerCase()?.includes(searchTerm)
            );
        },
        filteredItemsfromsearch() {
            let filteredData = this.formatedData.filter(item =>
                item.name?.toLowerCase().includes(this.search?.toLowerCase())
            );
            return filteredData;
        },
    },
    methods: {
        /**
         * Handler for filter-active-change event from DataTableAction
         */
        onFilterActiveChange(isActive) {
            this.hasActiveTableFilter = isActive;
        },
        /**
         * Clear table filters via DataTableAction ref
         */
        clearTableFilter() {
            if (this.$refs.dataTableAction) {
                this.$refs.dataTableAction.clearFilter();
            }
        },
        setPaginatedData(paginationInfo) {
            if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
                this.paginatedFilteredItems = paginationInfo.data || [];
                this.page = paginationInfo.page || 1;
            } else {
                this.paginatedFilteredItems = paginationInfo || [];
            }
        },
        refreshData() {
            this.projectId = this.$route.params.id || "";
            this.getData();
            this.formateData();
        },
        formateData() {
            let ObjectTemp = {};
            let ArrayTemp = [];
            this.listdata.forEach((item, index) => {
                ObjectTemp = {
                    __key: index,
                    __formatedkey: index,
                    _id: item._id,
                    indexno: index + 1,
                    name: item.locationName,
                    locationId: item.locationId,
                    threshold: item.threshold,
                    created_at: item.created_at,
                    updated_at: item.updated_at,
                    status: item.status,
                };
                ArrayTemp.push(ObjectTemp);
            });
            this.formatedData = ArrayTemp;
            this.formatedDataCopy = ArrayTemp;
            
        },
        addForm() {
            this.locationdialog = true;
            this.locationdata = { threshold: 0 };
            this.locationdataerror = {};
            this.locationUserList = [];
            this.customassertions = false;
        },
        async getData() {
            this.loading = true;
            await this.axios
                .post("/v2/financialclose/masters/threshold/get")
                .then(async (ele) => {
                    if (ele.data.status === "success") {
                        this.listdata = ele.data.data;
                        await this.axios
                            .post("/v2/financialclose/location/get")
                            .then((ele) => {
                                if (ele.data.status === "success") {
                                    this.locationListdata = ele.data.data;
                                    this.locationListdata.map(item => this.locationList.push(item.name))
                                    this.listdata = this.listdata.filter(obj1 => {
                                        var location = []
                                        location = this.locationListdata.filter(obj2 => {
                                            if (obj2._id === obj1.location) {
                                                return obj2;
                                            }
                                        });
                                        obj1.locationName = location[0].name
                                        return obj1
                                    })
                                    this.formateData()
                                }
                            })
                    }
                })
                .catch((err) => {
                    this.$store.commit("sbError", err.message || err || "Unknown error!");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /**
         * Validate threshold data fields before add/edit API call
         * Checks for null, undefined, empty, and length/number constraints
         * Returns an object with error messages for each invalid field
         */
        validateThresholdData(data) {
            const errors = {};
            // Name validation (assign to 'location' for UI binding)
            if (!data.name || typeof data.name !== 'string' || !data.name.trim() || data.name.trim().length < 2) {
                errors.location = 'Location name is required.';
            }
            // Threshold validation: must be present, a valid number, 0 is valid, but very nonzero values are not
            const thresholdNum = Number(data.threshold);
            if (
                data.threshold === null ||
                data.threshold === undefined ||
                data.threshold === '' ||
                (typeof data.threshold === 'string' && data.threshold.trim() === '') ||
                isNaN(thresholdNum) ||
                typeof thresholdNum !== 'number' ||
                !isFinite(thresholdNum)
            ) {
                errors.threshold = 'Threshold is required and must be a valid number.';
            } else if (thresholdNum < 0) {
                errors.threshold = 'Threshold must be 0 or greater.';
            } else if (thresholdNum !== 0 && Math.abs(thresholdNum) < 1e-8) {
                errors.threshold = 'Threshold value is too or empty.';
            }
            return errors;
        },

        addThreshold() {
            // Validate before API call
            const errors = this.validateThresholdData(this.locationdata);
            this.locationdataerror = errors;
            if (Object.keys(errors).length > 0) {
                this.$store.commit("sbError", "Please fill all required fields correctly.");
                return;
            }
            this.locationdialogloading = true;
            let locationId = this.locationListdata.filter((item) => {
                if (item.name === this.locationdata.name) {
                    return item._id;
                }
            })
            this.locationdata.location = locationId[0]?._id || ""
            this.locationdata = { ...this.locationdata, 'status': this.enableSwitch }
            this.axios
                .post("/v2/financialclose/masters/threshold/add", { data: this.locationdata })
                .then((ele) => {
                    if (ele.data.status === "success") {
                        this.locationdialog = false;
                        this.$store.commit("sbSuccess", ele.data.message || "Added Successfully");
                        this.refreshData();
                    } else {
                        if (ele.data.data.length > 0) {
                            if (ele.data.data[0].index0)
                                this.locationdataerror = ele.data.data[0].index0;
                        } else throw new Error(ele.data.message);
                    }
                })
                .catch((err) => {
                    this.$store.commit("sbError", err.message || err || "Unknown error!");
                })
                .finally(() => {
                    this.locationdialogloading = false;
                });
        },
        editThreshold(item) {
            this.locationdata = { ...item };
            this.locationdialog = true;
            this.enableSwitch = item.status
            this.locationdataerror = {};
            console.log(item);
        },
       enableDisableThreshold(item, action, status) {
        this.loading = true;
        const updatedItem = { ...item, status: !status };
        const url = `v2/financialclose/masters/threshold/edit/${item._id}`;
        this.axios.post(url, { data: updatedItem })
            .then(dt => {
            if (dt.data.status !== "success") {
                throw new Error(dt.data.message || "Error performing action");
            }
            this.refreshData();
            this.$store.commit("sbSuccess", `Threshold ${action}d`);
            })
            .catch(err => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.error(err);
            })
            .finally(() => {
            this.loading = false;
            });
        },
        updateThreshold(item) {
            // Validate before API call
            const errors = this.validateThresholdData(item);
            this.locationdataerror = errors;
            if (Object.keys(errors).length > 0) {
                this.$store.commit("sbError", "Please fill all required fields correctly.");
                return;
            }
            this.locationdialogloading = true;
            item.status = this.enableSwitch
            this.axios
                .post("v2/financialclose/masters/threshold/edit/" + item._id, { data: item })
                .then((ele) => {
                    if (ele.data.status === "success") {
                        this.locationdialog = false;
                        this.$store.commit("sbSuccess", ele.data.mssage || 'Updated successfully');
                        this.refreshData();
                    } else {
                        if (ele.data.data.length > 0) {
                            if (ele.data.data[0].index0)
                                this.locationdataerror = ele.data.data[0].index0;
                        } else throw new Error(ele.data.message);
                    }
                })
                .catch((err) => {
                    this.$store.commit("sbError", err.message || err || "Unknown error!");
                })
                .finally(() => {
                    this.locationdialogloading = false;
                });
        },
        toggleSwitch(item) {
            item.status = this.enableSwitch
        },
        getItemData(item, key) {
            return item[key];
        },
        addTableHeader(item) {
            this.headers.find((x) => x === item ? x.visible = !x.visible : "")
        },
        /**
         * Handle Apply button click from CustomizeColumnMenu
         * Updates column visibility locally (session only)
         * @param {Array} headers - Updated headers array
         */
        handleApplyColumns(headers) {
            this.headers = headers;
            this.customizeMenuOpen = false;
        },
    filterPart(item,header){
        console.log(item,header);
        // Save filter criteria for reapplication after data refresh
        this.activeFilter = JSON.parse(JSON.stringify(item));
        this.formatedData = this.$nova.filterByDynamicCriteria(this.formatedDataCopy, item);  
      },
    clearPart(item){
        console.log(item,"item");
        this.activeFilter = null;
        this.formatedData = this.formatedDataCopy;
        this.refreshData();
      }
    },
    watch: {
      // Reapply filter when data is refreshed
      formatedDataCopy: {
        handler(newList) {
          if (this.activeFilter) {
            this.formatedData = this.$nova.filterByDynamicCriteria(newList, this.activeFilter);
          } else {
            this.formatedData = newList;
          }
        },
        deep: true
      }
    },
};
</script>

<style></style>